import paths from '../../../../AppRouter/paths';

import FAQ from './icons/heart-handshake.svg';
import HowToPlay from './icons/howtoplay.svg';
import Prisez from './icons/prizes.svg';
import OfficialRules from './icons/rules.svg';
import Profile from './icons/user-profile-outline.svg';

export const linkData = [
  {
    linkName: 'Profile',
    path: `${process.env.REACT_APP_URL_GAMEZONE}/profile`,
    logo: Profile,
  },
  {
    linkName: 'Official Rules',
    path: paths.rules,
    logo: OfficialRules,
  },
  {
    linkName: 'How To Play',
    path: paths.guide,
    logo: HowToPlay,
  },
  {
    linkName: 'Prizes',
    path: paths.prize,
    logo: Prisez,
  },
  {
    linkName: 'FAQs',
    path: paths.faq,
    logo: FAQ,
  },
];
